// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"311":"pvStats","402":"energyStorageStats","580":"chargingStats"}[chunkId] || chunkId) + "." + {"282":"f575ee73c71d0bdd","311":"26c2f67ee812fa9f","402":"09c88889720c8db6","580":"2833b0f3c203d6ed"}[chunkId] + ".js";
};